<template>
  <div class="tab-item output row">
     <div class="col-lg-2 col-sm-2 iconleft"> <img src="/static/img/ic-check.png"></div>
        <div class="col-lg-10 col-sm-10">
           <div class="content">
                <h1> <router-link :to="{ name: 'resourceView', params: { id: output.resource.id }}">{{ output.resource.title }}</router-link></h1>
                  <p>
                    <span class="text-justify">{{ output.resource.description }}</span></p>
            </div>
      </div>
  </div>
  <!--<b-media tag="li">
    <template v-slot:aside>
      <span :style="adjustColor(output.resource.mediaType)" >
        <font-awesome-icon
         
        :icon="adjustIcon(output.resource.mediaType)"
        :size="adjustIconSize(output.resource.mediaType)"
         ></font-awesome-icon>
      </span>
    </template>
    <h5 class="mt-0 mb-3 text-left">
      <router-link :to="{ name: 'resourceView', params: { id: output.resource.id }}">{{ output.resource.title }}</router-link>
    </h5>
    <p class="mb-0 text-left">
      <span class="text-justify">{{ output.resource.description }}</span>
    </p>
  </b-media>-->
</template>

<script>
export default {
  name: 'RecipeOutcome',
  props: {
    output: Object
  },
  methods: {
    adjustIcon (mediaType) {
      // load the proper icon given the media type 
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'file-audio'
      } else if (mediaType === 'Linked Video') {
        return 'play-circle'
      } else if (mediaType === 'Website') {
        return 'link'
      } else if (mediaType === 'Text') {
        return 'file-alt'
      } else if (mediaType === 'Pdf') {
        return 'file-pdf'
      } else {
        return 'file-alt'
      }
    },
    adjustIconSize (mediaType) {
      // load the proper icon given the media type 
      if (mediaType === 'Image') {
        return '4x'
      } else if (mediaType === 'Audio') {
        return '5x'
      } else if (mediaType === 'Linked Video') {
        return '4x'
      } else if (mediaType === 'Website') {
        return '4x'
      } else if (mediaType === 'Text') {
        return '5x'
      } else if (mediaType === 'Pdf') {
        return '5x'
      } else {
        return '5x'
      }
    },
    adjustColor (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'color: #f0d6f1'
      } else if (mediaType === 'Linked Video') {
        return 'color: #ff6c6c'
      } else if (mediaType === 'Website') {
        return 'color: #95c9ff'
      } else if (mediaType === 'Text') {
        return 'color: #fff37a'
      } else if (mediaType === 'Pdf') {
        return 'color: red'
      } else {
        return 'color: #fff37a'
      }
    }
  }
}
</script>

<style scoped>
.media-wrapper {
  width: 64px;
  height: 64px
}
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeOutput.vue